module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<form id="merchant-forcePassChange-form">\n    ';
 if (data.password_expired) { ;
__p += '\n    <div class="alert-danger">\n        Hi ' +
__e( data.first_name ) +
', your password has expired.<br/>Please update it now.\n    </div>\n    ';
 } else { ;
__p += '\n    <h1 class="welcome">Hi ' +
__e( data.first_name ) +
', welcome to Pazien!</h1>\n    <h2>' +
((__t = ( strings.login.newPasswordPrompt )) == null ? '' : __t) +
'</h2>\n    ';
 } ;
__p += '\n    <div id="login-status" class="alert alert-danger hidden" role="alert"></div>\n\n    <div class="form-group new-password"></div>\n    <div class="submit-btn-block">\n        <button class="btn btn-lg btn-primary btn-last-step change-password" disabled="true">' +
((__t = ( strings.login.saveNewPassword )) == null ? '' : __t) +
'</button>\n    </div>\n</form>\n';
return __p
}